// eslint-disable-next-line no-restricted-imports
import { forwardRef as reactForwardRef } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-types
export function forwardRef(render) {
  return /*#__PURE__*/reactForwardRef(render);
}
//# sourceMappingURL=forward-ref.js.map